export default __webpack_public_path__ + "static/media/blustreamApp.9e3e8edc.png";